import type { TrackerFdfcEntry } from '@tracker/shared';
import { Badge } from '@/components/ui/badge';
import { DISPATCH_LABEL, NSDC_STATUS_LABEL } from './dispatch-labels';

/** Where an entry stands with NSDC; `inline` puts the order code beside the badge instead of under it. */
export function DispatchBadge({ entry, inline = false }: { entry: TrackerFdfcEntry; inline?: boolean }) {
  const s = entry.dispatch_status;
  if (s === 'dispatched') {
    const nsdc = entry.nsdc_status;
    const variant = nsdc === 'delivered' ? 'success' : nsdc === 'returned' || nsdc === 'cancelled' ? 'destructive' : 'default';
    return (
      <div className={inline ? 'inline-flex items-center gap-1.5' : 'space-y-0.5'}>
        <Badge variant={variant}>{nsdc ? NSDC_STATUS_LABEL[nsdc] : 'Sent'}</Badge>
        <div className="font-mono text-[11px] text-muted-foreground">
          {entry.nsdc_order_code}
          {entry.nsdc_order_count > 1 && <span className="font-sans"> · {entry.nsdc_order_count} orders</span>}
        </div>
      </div>
    );
  }
  const variant = s === 'failed' ? 'destructive' : s === 'unknown' || s === 'dispatching' ? 'warning' : 'secondary';
  return (
    <span title={entry.dispatch_error ?? undefined}>
      <Badge variant={variant}>{DISPATCH_LABEL[s]}</Badge>
    </span>
  );
}
